module.exports = __webpack_public_path__ + "230b57730caf99fc168454ded893c5fa.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-122@2x.png
// module id = 501
// module chunks = 0